import { SelectFields } from '@repo/toolkit/types'

import { HostFamily } from '../../models/host-family/host-family'
import { FieldsSelector } from '../../utils'

export const enrollmentHostFamilyFields = [
  'id',
  'familyName',
  'address1',
  'address2',
  'zipCode',
  'city',
  'country',
  'parent1FirstName',
  'parent1Position',
  'parent1PhoneNumber',
  'parent2FirstName',
  'parent2Position'
] as const satisfies FieldsSelector<HostFamily>

export type EnrollmentHostFamilyType = SelectFields<HostFamily, typeof enrollmentHostFamilyFields>
